// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chartContainer {
  display: flex;
  flex-direction: row;
  height: 250px;
}

.legend {
  flex: 0 0 auto;
  display: block;
  padding: 0 10px;
  border-bottom: 30px solid transparent;
  overflow-y: auto;
  overflow: -moz-scrollbars-vertical;

  &::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 5px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, .1);
    -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, .5);
  }

}

.chart {
  flex: 1 1 auto;
  min-width: 0;
}
`, "",{"version":3,"sources":["webpack://./src/examples/auxiliary/bullet-legend/vertical-legend/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,qCAAqC;EACrC,gBAAgB;EAChB,kCAAkC;;EAElC;IACE,wBAAwB;IACxB,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,mCAAmC;IACnC,mDAAmD;EACrD;;AAEF;;AAEA;EACE,cAAc;EACd,YAAY;AACd","sourcesContent":[".chartContainer {\n  display: flex;\n  flex-direction: row;\n  height: 250px;\n}\n\n.legend {\n  flex: 0 0 auto;\n  display: block;\n  padding: 0 10px;\n  border-bottom: 30px solid transparent;\n  overflow-y: auto;\n  overflow: -moz-scrollbars-vertical;\n\n  &::-webkit-scrollbar {\n    -webkit-appearance: none;\n    width: 5px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    border-radius: 4px;\n    background-color: rgba(0, 0, 0, .1);\n    -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, .5);\n  }\n\n}\n\n.chart {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chartContainer": `chartContainer`,
	"legend": `legend`,
	"chart": `chart`
};
export default ___CSS_LOADER_EXPORT___;
